import React, { useState } from "react";
import { Button, Dropdown, Badge, Typography } from "antd";
import { SwapOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { tenantAssets } from "../../shared/config/tenantConfiguration";

const { Text } = Typography;

/**
 * TenantSwitcher Component
 * Development-only component to preview different tenant themes
 * 
 * IMPORTANT: This should only be visible in development environment
 * Add condition: process.env.NODE_ENV === 'development' when using
 */
const TenantSwitcher = ({ currentTenant }) => {
  const [open, setOpen] = useState(false);

  // Get all available tenants
  const availableTenants = Object.keys(tenantAssets);

  const handleTenantSwitch = (tenantKey) => {
    // Store selected tenant KEY in localStorage
    localStorage.setItem("dev_tenant_override", tenantKey);
    
    // Reload to apply changes (getTenant() will pick it up)
    window.location.reload();
  };

  const clearOverride = () => {
    localStorage.removeItem("dev_tenant_override");
    window.location.reload();
  };

  // Get current tenant key from localStorage
  const currentTenantKey = localStorage.getItem("dev_tenant_override");
  const currentTenantData = currentTenantKey ? tenantAssets[currentTenantKey] : null;

  const menuItems = availableTenants.map((key) => {
    const tenant = tenantAssets[key];
    const isActive = currentTenantKey === key;
    
    return {
      key: key,
      label: (
        <div
          onClick={() => handleTenantSwitch(key)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "8px 12px",
            minWidth: "280px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              backgroundColor: tenant.theme.colorPrimary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              strong
              style={{
                color: "#fff",
                fontSize: "12px",
              }}
            >
              {tenant.companyName.substring(0, 2).toUpperCase()}
            </Text>
          </div>
          <div style={{ flex: 1 }}>
            <Text strong style={{ display: "block", fontSize: "14px" }}>
              {tenant.companyName}
            </Text>
            <Text type="secondary" style={{ fontSize: "12px" }}>
              {tenant.theme.colorPrimary}
            </Text>
          </div>
          {isActive && (
            <CheckCircleOutlined
              style={{ fontSize: "18px", color: tenant.theme.colorPrimary }}
            />
          )}
        </div>
      ),
    };
  });

  // Add separator and clear option
  menuItems.push(
    { type: "divider" },
    {
      key: "clear",
      label: (
        <div
          onClick={clearOverride}
          style={{
            padding: "8px 12px",
            textAlign: "center",
          }}
        >
          <Text type="danger">Clear Override (Use Domain)</Text>
        </div>
      ),
    }
  );

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={["click"]}
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
    >
      <Badge
        count={
          <div
            style={{
              backgroundColor: "#ff4d4f",
              color: "#fff",
              fontSize: "10px",
              padding: "2px 6px",
              borderRadius: "10px",
              fontWeight: "bold",
            }}
          >
            DEV
          </div>
        }
        offset={[-5, 5]}
      >
        <Button
          type="primary"
          icon={<SwapOutlined />}
          style={{
            backgroundColor: currentTenantData 
              ? currentTenantData.theme.colorPrimary 
              : "#1890ff",
            borderColor: currentTenantData 
              ? currentTenantData.theme.colorPrimary 
              : "#1890ff",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <span style={{ fontSize: "12px", fontWeight: "500" }}>
            {currentTenantData ? currentTenantData.companyName : "Switch Tenant"}
          </span>
        </Button>
      </Badge>
    </Dropdown>
  );
};

export default TenantSwitcher;
